import { render, staticRenderFns } from "./memberUpgrade.vue?vue&type=template&id=cbb40434&scoped=true&"
import script from "./memberUpgrade.vue?vue&type=script&lang=js&"
export * from "./memberUpgrade.vue?vue&type=script&lang=js&"
import style0 from "./memberUpgrade.vue?vue&type=style&index=0&id=cbb40434&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbb40434",
  null
  
)

export default component.exports